TYPE_AUTH_JSON